/* External */
import { call, put, takeEvery } from 'redux-saga/effects';

/* ActionTypes */
import { FETCH_SEASON_BY_ID } from './actionTypes';

/* Actions */
import { addToEntities } from '../utils/actions';

/* Sagas */
import { requestSaga } from '../requests/sagas';
import { authenticatedSaga } from '../utils/sagas';

/* Services */
import backendService from '../../services/backendService';

function fetchSeasonByIdService({
  showId,
  seasonNumber,
}) {
  return backendService.content.v1.getSeasonDetail(showId, seasonNumber);
}

function* fetchSeasonByIdSaga(action) {
  try {
    const response = yield call(requestSaga, fetchSeasonByIdService, action);
    if (response) {
      const { normalizedData: { entities } } = response;
      yield put(addToEntities(entities));
    }
  } catch (error) {
    console.error('seasons>fetchSeasonByIdSaga', error);
  }
}

function* fetchSeasonById() {
  yield takeEvery(FETCH_SEASON_BY_ID, authenticatedSaga(fetchSeasonByIdSaga));
}

export default [
  fetchSeasonById,
];
